const projectConfig = {
	enableAnalytics: false,
};

export default projectConfig;
